// add attribute to allow button text to be empty
(function(angular) {
    'use strict';

    // attribute to tell paging to not return the normal text for buttons
    var emptyButtonText = 'apEmptyButtonText';

    angular.module('aprima-core-ui').decorator('uibPaging', [
        '$delegate', 
        uibPagingDecorator
    ]);

    function uibPagingDecorator(
        $delegate
    ) {

        var create = $delegate.create;
        if(!create) {
            return $delegate;
        }

        $delegate.create = function(ctrl, $scope, $attrs) {
            var result = create.apply(this, arguments);

            if($scope.$eval($attrs[emptyButtonText])) {
                $scope.getText = angular.noop;
            }
            return result;
        };

        return $delegate;
    }

})(window.angular);
